/**
 * jQuery Formset 1.2
 *
 * Forked from https://github.com/elo80ka/django-dynamic-formset
 * and modified by CloudBolt. Copied from src/static_src/js/other/jquery.formset.js and modified again
 * Called in the Users/Groups -> Bulk Update view, used by calling `.formset({})` on a jquery element
 * Formset appears to be called in c2Archive.customReportCommon.js and c2Archive.networkTableAndFormset.js
 *
 *
 *    ---
 *    Warning: this plugin was customized for CB
 *    and is no longer a general purpose solution
 *    ---
 *
 * @author Stanislaus Madueke (stan DOT madueke AT gmail DOT com)
 * @requires jQuery 1.2.6 or later
 *
 * Copyright (c) 2009, Stanislaus Madueke
 * All rights reserved.
 *
 * Licensed under the New BSD License
 * See: http://www.opensource.org/licenses/bsd-license.php
 */
;(function($) {
    $.fn.formset = function(opts)
    {
        var options = $.extend({}, $.fn.formset.defaults, opts),
            flatExtraClasses = options.extraClasses.join(' '),
            $$ = $(this),

            applyExtraClasses = function(row, ndx) {
                if (options.extraClasses) {
                    row.removeClass(flatExtraClasses);
                    row.addClass(options.extraClasses[ndx % options.extraClasses.length]);
                }
            },

            updateElementIndex = function(elem, prefix, ndx) {
                var idRegex = new RegExp('(' + prefix + '-\\d+-)|(^)'),
                    replacement = prefix + '-' + ndx + '-';
                if (elem.attr("for")) elem.attr("for", elem.attr("for").replace(idRegex, replacement));
                if (elem.attr('id')) elem.attr('id', elem.attr('id').replace(idRegex, replacement));
                if (elem.attr('name')) elem.attr('name', elem.attr('name').replace(idRegex, replacement));
            },

            hasChildElements = function(row) {
                return row.find('input,select,textarea,label').length > 0;
            },

            addForm = function () {
                var formCount = parseInt($('#id_' + options.prefix + '-TOTAL_FORMS').val()),
                    row = options.formTemplate.clone(true).removeClass('formset-custom-template'),
                    buttonRow = $(this).parents('tr.' + options.formCssClass + '-add').get(0) || this;
                applyExtraClasses(row, formCount);
                row.insertBefore($(buttonRow)).show();
                row.find('input,select,textarea,label').each(function() {
                    updateElementIndex($(this), options.prefix, formCount);
                });
                $('#id_' + options.prefix + '-TOTAL_FORMS').val(formCount + 1);
                // If a post-add callback was supplied, call it with the added form:
                if (options.added) options.added(row);
                return false;
            },

            deleteForm = function(event) {
                var row = $(this).parents('.' + options.formCssClass),
                    del = row.find('input:hidden[id $= "-DELETE"]');
                if (del.length) {
                    // We're dealing with an inline formset; rather than remove
                    // this form from the DOM, we'll mark it as deleted and hide
                    // it, then let Django handle the deleting:
                    del.val('on');
                    if (!options.removedRowsClass) {
                        row.hide();
                    } else {
                        row.addClass(options.removedRowsClass);

                        $('a.unremove').off('click');
                        $(this).replaceWith(
                            '<span class="unremoveWrap">' +
                            '  <a class="unremove">' + gettext("Undo") + '</a>' +
                            '</span>');
                        $('a.unremove').on('click', unremoveRow);
                    }
                } else {
                    row.remove();
                    // Update the TOTAL_FORMS form count.
                    // Also update names and IDs for all remaining form controls so they remain in sequence:
                    var forms = $('.' + options.formCssClass).not('.formset-custom-template');
                    $('#id_' + options.prefix + '-TOTAL_FORMS').val(forms.length);
                    for (var i=0, formCount=forms.length; i<formCount; i++) {
                        applyExtraClasses(forms.eq(i), i);
                        forms.eq(i).find('input,select,textarea,label').each(function() {
                            updateElementIndex($(this), options.prefix, i);
                        });
                    }
                }
                // If a post-delete callback was provided, call it with the deleted form:
                if (options.removed) options.removed(row);
                return false;
            },

            unremoveRow = function(event) {
                event.preventDefault();
                var row = $(this).closest('.' + options.removedRowsClass);
                var del = row.find('input:hidden[id $= "-DELETE"]');
                del.val('');
                row.removeClass(options.removedRowsClass);
                $(this).closest('.unremoveWrap').remove();
                insertDeleteLink(row);
                if (options.unremoved) options.unremoved(row);
            },

            deleteAllForms = function(event) {
                event.preventDefault();
                var row = $(this).parents('.formset-controls');
                var rows = row.siblings();
                rows.find('.delete-form').trigger('click');
            },

            insertDeleteLink = function(row) {
                // Build the anchor programmatically instead of via HTML string
                // interpolation so the developer-configured class/label options
                // don't trip CodeQL's html-constructed-from-input rule. The
                // label is intentional HTML (icon markup), so it goes via
                // .html() rather than .text().
                var $deleteLink = $('<a>')
                    .attr('class', options.deleteClass)
                    .html(options.deleteLabel);
                if (row.is('TR')) {
                    // If the forms are laid out in table rows, insert
                    // the remove button into the last table cell:
                    row.children(':last').append($deleteLink);
                    parent_sel = 'tr';
                } else if (row.is('UL') || row.is('OL')) {
                    // If they're laid out as an ordered/unordered list,
                    // insert an <li> after the last list item:
                    var $li = $('<li></li>');
                    $li.append($deleteLink);
                    row.append($li);
                    parent_sel = 'li';
                } else {
                    // Otherwise, just insert the remove button as the
                    // last child element of the form's container:
                    row.append($deleteLink);
                    parent_sel = '';
                }

                $deleteLink.click(deleteForm);
            };

        $$.each(function(i) {
            var row = $(this),
                del = row.find('input:checkbox[id $= "-DELETE"]');
            if (del.length) {
                // If you specify "can_delete = True" when creating an inline formset,
                // Django adds a checkbox to each form in the formset.
                // Replace the default checkbox with a hidden field:
                del.before(
                    $('<input>').attr({
                        type: 'hidden',
                        name: del.attr('name'),
                        id: del.attr('id')
                    })
                );
                del.remove();
            }
            if (hasChildElements(row)) {
                insertDeleteLink(row);
                row.addClass(options.formCssClass);
                applyExtraClasses(row, i);
            }
        });

        if ($$.length) {
            var template;
            if (options.formTemplate) {
                // If a form template was specified, we'll clone it to generate new form instances:
                template = (options.formTemplate instanceof $) ? options.formTemplate : $(options.formTemplate);
                template.removeAttr('id').addClass(options.formCssClass).addClass('formset-custom-template');
                template.find('input,select,textarea,label').each(function() {
                    updateElementIndex($(this), options.prefix, 2012);
                });
                insertDeleteLink(template);
            } else {
                // Otherwise, use the last form in the formset; this works much better if you've got
                // extra (>= 1) forms (thnaks to justhamade for pointing this out):
                template = $('.' + options.formCssClass + ':last').clone(true).removeAttr('id');
                template.find('input:hidden[id $= "-DELETE"]').remove();
                template.find('input,select,textarea,label').each(function() {
                    var elem = $(this);
                    // If this is a checkbox or radiobutton, uncheck it.
                    // This fixes Issue 1, reported by Wilson.Andrew.J:
                    if (elem.is('input:checkbox') || elem.is('input:radio')) {
                        elem.attr('checked', false);
                    } else {
                        elem.val('');
                    }
                });
            }

            // FIXME: Perhaps using $.data would be a better idea?
            options.formTemplate = template;
            var $controls;
            var $addLink = $('<a>')
                .attr('class', options.addClass)
                .html(options.addLabel)
                .on('click', addForm);

            // Insert 'Add' and optional 'Delete All' links as appropriate
            // for the context
            var containerTag = $$.prop('tagName');
            if (containerTag == 'TR') {
                var numCols = $$.eq(0).children().length;
                var controls = '<tr class="formset-controls">';
                // Use for loop instead of repeat() for IE11 compatibility
                for (i=0; i < numCols-1; i++) {
                    controls += "<td></td>";
                }
                controls += '<td class="shrink text-center"></td>';
                controls += '</tr>';
                $controls = $(controls);
                $controls.find('td:eq(0)').append($addLink);

                if (options.showDeleteAllLink) {
                    var $deleteAllLink = $('<a>')
                        .attr('class', options.deleteAllClass)
                        .html(options.deleteAllLabel)
                        .on('click', deleteAllForms);
                    var lastIndex = numCols-1;
                    $controls.find('td:eq('+lastIndex+')').append($deleteAllLink);
                }

                $$.parent().append($controls);
            } else if (containerTag == 'LI') {
                console.log('c2 jquery.formset does not support lists.');
            } else {
                // Otherwise, insert it immediately after the last form:
                $controls = $('<div class="formset-controls"></div>');
                $controls.append($addLink);
                if (options.showDeleteAllLink) {
                    $addLink.after($deleteAllLink);
                }
                $$.filter(':last').after($controls);
            }
            $controls.addClass(options.formCssClass + '-add');
        }

        if (options.removedRowsClass) {
            $('a.unremove').on('click', unremoveRow);
        }

        return $$;
    };

    /* Setup plugin defaults */
    $.fn.formset.defaults = {
        prefix: 'form',                  // The form prefix for your django formset
        formTemplate: null,              // The jQuery selection cloned to generate new form instances

        // *Label option sets the content of the anchor tag
        // *Class sets the CSS class or classes
        addLabel: '<span class="bi bi-plus"></span> ' + gettext("Add Another"),
        addClass: 'btn btn-link btn-link-xs add-form',

        deleteLabel: '<span class="bi bi-x-lg"></span>',
        deleteClass: 'btn btn-link btn-link-xs p-1 delete-form',

        showDeleteAllLink: true,
        deleteAllLabel: '<span class="bi bi-x-lg"></span> ' + gettext("Remove All"),
        deleteAllClass: 'btn btn-link btn-link-xs p-1 delete-forms',

        formCssClass: 'dynamic-form',    // CSS class applied to each form in a formset
        extraClasses: [],                // Additional CSS classes, which will be applied to each form in turn
        added: null,                     // Function called each time a new form is added. Row is passed.
        removed: null,                   // Function called each time a form is deleted. Row is passed.
        unremoved: null,                 // Callback for when a pending removal is canceled. Row is passed.
        hideRemovedRows: true,           // If false, make sure to indicate state via removed callback
        removedRowsClass: 'toBeRemoved'  // If not empty, mark the row instead of hiding; also change the link to cancel
    };
})(jQuery)
